import theme from 'assets/style/theme';

const style = {
    stack: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    createApprovalButton: {
        marginBottom: 1,
        padding: '8px 24px !important',
        fontWeight: '700',
        fontFamily: (themes) => themes.typography.fontFamily,
        textWrap: 'nowrap',
        borderRadius: (themes) => themes.palette.border.$border_radius,
        backgroundColor: (themes) => themes.palette.blue.strongDark,
        boxShadow: 'none !important',
        '&:hover': {
            backgroundColor: (themes) => themes.palette.button.$color_button_primary_hover,
        },
        '&:active': {
            backgroundColor: (themes) => themes.palette.button.$color_button_primary_active,
        },
    },
    cancelApprovalButton: {
        marginBottom: 1,
        padding: '8px 24px !important',
        fontWeight: '700',
        textTransform: 'none',
        fontFamily: (themes) => themes.typography.fontFamily,
        textWrap: 'nowrap',
        borderRadius: (themes) => themes.palette.border.$border_radius,
        color: (themes) => themes.palette.blue.strongDark,
        border: (themes) => `1px solid ${themes.palette.blue.strongDark}`,
        boxShadow: 'none !important',
        '&:hover': {
            color: (themes) => themes.palette.button.$color_button_primary_hover,
            border: (themes) => `1px solid ${themes.palette.button.$color_button_primary_hover} !important`,
        },
        '&:active': {
            color: (themes) => themes.palette.button.$color_button_primary_active,
            border: (themes) => `1px solid ${themes.palette.button.$color_button_primary_active} !important`,
        },
    },
    ruleMultiSelect: {
        select: {
            '& label.Mui-focused': {
                color: '#0047BA',
            },

            '& label.MuiInputLabel-shrink': {
                color: '#0047BA',
                padding: '0 2px',
                fontWeight: 700,
            },
        },
        chip: {
            '& svg.MuiChip-deleteIcon': {
                color: 'red',
            },
            borderRadius: '5px',
            height: '20px',
        },
        deleteIcon: { fontSize: '14px', color: '#707070' },
    },
    deleteModal: {
        deleteMsgWrap: { textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' },
        actionWrapper: { display: 'flex', justifyContent: 'center', mt: 2 },
        yesCircularProg: { marginLeft: '10px' },
        noBtn: {
            marginLeft: '10px',
            textTransform: 'none',
            color: '#6E6F6F',
            border: '2px solid #707070',
            backgroundColor: '#ffffff',
            '&:hover': {
                color: '#6E6F6F',
                border: '2px solid #707070',
                backgroundColor: '#ffffff',
            },
        },
        modalMsg: { textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' },
        checkCircleICon: { fontSize: '50px', color: '#16BF5E' },
        defaultsMsg: { color: '#626262', fontSize: '18px' },
        continueWrapper: { display: 'flex', justifyContent: 'center', mt: 2 },
        laterBtn: { marginLeft: '10px' },
    },
    list: {
        circularIcon: { marginLeft: theme.spacing(1.25), color: '#0047BA' },
        userIcon: { fontSize: '27px', marginTop: '5px' },
        wrapper: {
            background: theme.palette.background.$color_background_default,
            color: theme.palette.white,
            flexGrow: 1,
            overflow: 'auto',
            display: 'flex',
            paddingTop: theme.spacing('26px'),
            paddingBottom: theme.spacing(1),
            backgroundColor: theme.palette.grey.lighter,
            paddingX: theme.spacing('53px'),
        },
        tableContainer: {
            marginTop: theme.spacing(0.5),
            borderRadius: '3px',
            boxShadow: '1px 1px 2px #00000014',
            background: theme.palette.background.$color_background_layer_01,
        },
        table: {
            marginTop: theme.spacing(-1.125),
            borderSpacing: theme.spacing(0),
            paddingTop: theme.spacing(1),
            minWidth: 500,
            height: 'auto',
        },
        row: { height: theme.spacing('50px') },
        hrow: { height: theme.spacing('50px'), backgroundColor: theme.palette.blue.main },

        emptyRow: {
            row: { background: 'transparent !important' },
            cell: { border: '0 !important' },
        },
        editBtn: {
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: theme.spacing(3),
            height: theme.spacing(3),
        },
        editIcon: {
            width: '16px',
            height: '16px',
            color: theme.palette.white,
            cursor: 'pointer',
            marginLeft: '3px',
        },
        deleteBtn: {
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: theme.spacing(3),
            height: theme.spacing(3),
        },
        deleteIcon: {
            color: theme.palette.white,
            cursor: 'pointer',
            width: '16px',
            height: '16px',
        },
        paginationWrapper: {
            direction: 'column',
            justifyContent: 'center',
            paddingX: theme.spacing('52px'),
        },
        paginationSubWrapper: {
            direction: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        tableFooter: { height: '70px', border: '1px solid rgba(224, 224, 224, 1)' },
        tablePagination: {
            width: '100%',
            color: theme.palette.black.dark,
            border: '1px solid #E0E0E0',

            '.MuiTablePagination-spacer': {
                flex: 0,
            },
            '.MuiToolbar-root': {
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row-reverse',
                alignItems: 'center',
            },
            '.MuiTablePagination-displayedRows': {
                fontWeight: 500,
                fontSize: '1rem',
                color: '#1E1E1E',
                paddingTop: '2px',
            },
        },
    },
    seletedFieldlabel: {
        '& label.Mui-focused': {
            color: '#0047BA',
        },
        '& label.MuiInputLabel-shrink': {
            color: '#0047BA',
            padding: '0 2px',
        },
    },
    searchIcon: {
        cursor: 'pointer',
        color: '#A5A5A5',
        icon: {
            '& .MuiInputBase-root': {
                paddingRight: '10px !important',
            },
        },
    },
    delegateModal: {
        wrapper: { minWidth: (themes) => themes.spacing(60), width: 'auto', display: 'flex', height: '100%', flexDirection: 'column', overflow: 'hidden' },
        contentWrapper: { overflow: 'auto', pt: (themes) => themes.spacing(2), height: '100%' },
        rowWrapper: { display: 'flex', mb: (themes) => themes.spacing(2), width: '100%' },
        delegateWrapper: { width: '120%' },
        actionWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: (themes) => themes.spacing(2) },
        warningTypography: { color: (themes) => themes.palette.red.light },
    },
    textField: {
        width: '100%',
        '& label.Mui-focused': {
            color: (themes) => themes.palette.blue.main,
        },
        '& label.MuiFormLabel-filled': {
            color: (themes) => themes.palette.blue.main,
            padding: (themes) => themes.spacing(0.5),
        },
        '& .MuiOutlinedInput-input': {
            height: (themes) => themes.spacing(0.75),
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: (themes) => themes.palette.textColors.$color_text_tertiary,
                color: (themes) => themes.palette.border.$color_border_input,
            },
            '&:hover fieldset': {
                borderColor: (themes) => themes.palette.border.$color_border_input_hover,
            },
            '&.Mui-focused fieldset': {
                color: (themes) => themes.palette.textColors.$color_text_primary,
                border: (themes) => `2px solid ${themes.palette.border.$color_border_input_focus}`,
            },
        },
    },
    notes: {
        color: (themes) => themes?.palette?.black?.dark,
        fontSize: (themes) => themes.spacing(1.75),
        fontWeight: 'regular',
        fontFamily: (themes) => themes.typography.fontFamily,
        paddingTop: (themes) => themes.spacing(2),
    },
    noteBold: {
        fontWeight: '700',
        paddingRight: '2px',
    },
};

export default style;
